module.exports = __webpack_public_path__ + "static/media/Jarnmagistern.704efbb9.png";